module.exports = "<li class=c-nav__list-item ng-if=\"$ctrl.isLoginAllowed() && !$ctrl.isLoggedIn()\"> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.login()>Log in</a> </li> <li ng-if=$ctrl.isLoggedIn()> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.logout()>Log out</a> <span class=c-nav__list-item__description>Logged in as: {{ $ctrl.storeService.get('client_name') }}</span> </li> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/logInOut.menu.html
// module id = 790
// module chunks = 0